import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Admin } from './Admin';
import { App } from './App';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('No #root element to mount into');

// Two pages, no router.
const isAdmin = window.location.pathname.replace(/\/+$/, '') === '/admin';

createRoot(container).render(<StrictMode>{isAdmin ? <Admin /> : <App />}</StrictMode>);
